/**
 * The `unauthorized` segment is what tells admin service to skip its ACL check,
 * which has no permission row for mandateRefund yet. Drop that segment on both
 * once dashboard-mandateRefund-resolve and -execute exist.
 */
export const MANDATE_REFUND_ENDPOINTS = {
	RESOLVE: '/dashboard/unauthorized/mandateRefund-mandateRefund-resolve',
	EXECUTE: '/dashboard/unauthorized/mandateRefund-mandateRefund-execute'
};
